import { DEFAULT_WORKDAY_START_HOUR, DEFAULT_WORKDAY_STOP_HOUR } from './constants';

export type UserConfigurationState = {
  organizationID: string;
  userID: string;
  workday: {
    start: number;
    stop: number;
  };
  selectedHospitalID: string;
  timeFormat: '12hr' | '24hr';
};

export const emptyConfiguration: UserConfigurationState = {
  organizationID: '',
  userID: '',
  workday: {
    start: DEFAULT_WORKDAY_START_HOUR,
    stop: DEFAULT_WORKDAY_STOP_HOUR,
  },
  selectedHospitalID: '',
  timeFormat: '24hr',
};
